export class OwnMath {
  public static round(value: number, decimals: number): number {
    const multiplier = Math.pow(10, decimals);

    const result = Math.round(value * multiplier) / multiplier;
    return result;
  }
}
